module.exports = __webpack_public_path__ + "static/media/cairrlogo.44aed411.png";